export default __webpack_public_path__ + "static/aderenciaSistemas1-e87b299df050c271ab874eba7d3e1757.jpeg";